import { createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "app/auth/base";
import { closeLoading, openLoading } from "app/store/trackingApp/loadingSlice";
import { openToast } from "app/store/trackingApp/toastSlice";
import { openModalError } from "app/store/trackingApp/modalErrorSlice";
import { getUserSetup } from "app/user-setup/store/userSetup.actions";

export const getDetalhesById = createAsyncThunk(
  "matrizConfigApp/detalhesPedido/getDetalhesById",
  async (
    data: { idUsuario: string; pagina: number; itensPorPagina: number },
    { dispatch }
  ) => {
    const { idUsuario, pagina, itensPorPagina } = data;
    let response: any;
    dispatch(openLoading());
    try {
      response = await API.get(`/user-setup/${idUsuario}`, {
        params: { pagina, itensPorPagina },
      });
    } catch (err) {
      dispatch(
        openModalError({
          title: "Não foi possível buscar os detalhes!",
          text: "Se certifique que os dados digitados estão corretos",
          btnLabel: "Voltar",
        })
      );
      console.error(err);
    }
    dispatch(closeLoading());
    return response.data;
  }
);

export const getMatrizCampos = createAsyncThunk(
  "matrizConfigApp/camposDetalhe/getMatrizCampos",
  async (data: object, { dispatch, getState }) => {
    const requestGetParams: any = getState();

    let response;
    dispatch(openLoading());
    try {
      response = await API.get("/matriz-campos", {
        params: data,
      });
    } catch (err) {
      dispatch(
        openModalError({
          title: "Não foi possível buscar os campos!",
          text: "Se certifique que os dados digitados estão corretos",
          btnLabel: "Voltar",
        })
      );
      console.error(err);
    }
    dispatch(closeLoading());
    return {
      ...response.data,
      idUsuario: requestGetParams.auth.info.idTokenClaims.oid,
    };
  }
);

export const getDetalhesInitialById = createAsyncThunk(
  "matrizConfigApp/detalhesPedido/getDetalhesInitialById",
  async (data: {
    idUsuario: string;
    pagina: number;
    itensPorPagina: number;
  }) => {
    const { idUsuario, pagina, itensPorPagina } = data;
    let response: any;
    try {
      response = await API.get(`/user-setup/${idUsuario}`, {
        params: { pagina, itensPorPagina },
      });
    } catch (err) {
      console.error(err);
    }
    return response.data;
  }
);

export const saveDetalhes = createAsyncThunk(
  "matrizConfigApp/detalhesPedido/saveDetalhes",
  async (data: object, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    try {
      await API.post("/user-setup", data);
      dispatch(
        openToast({
          severity: "success",
          title: "Campos cadastrados",
        })
      );
      dispatch(
        getDetalhesById(
          requestGetParams.matrizConfigApp.detalhesPedido.requestGetParams
        )
      );
    } catch (err) {
      dispatch(
        openModalError({
          title: "Não foi possível cadastrar a ocorrência!",
          text: "Se certifique que os dados digitados estão corretos",
          btnLabel: "Voltar",
        })
      );
      console.error(err);
    }
    return {};
  }
);

export const editDetalhes = createAsyncThunk(
  "matrizConfigApp/detalhesPedido/editDetalhes",
  async (data: object, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    try {
      await API.put("/user-setup", data);
      dispatch(
        openToast({
          severity: "success",
          title: "Campos editados",
        })
      );
      dispatch(
        getUserSetup(
          requestGetParams.matrizConfigApp.detalhesPedido.requestGetParams
        )
      );
    } catch (err) {
      dispatch(
        openModalError({
          title: "Não foi possível editar os campos!",
          text: "Se certifique que os dados digitados estão corretos",
          btnLabel: "Voltar",
        })
      );
      console.error(err);
    }
    return {};
  }
);

export const deleteDetalhesPedido = createAsyncThunk(
  "matrizConfigApp/detalhesPedido/deleteDetalhesPedido",
  async (data: any, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    const { idTipoDocumento, idCodigoLegado, idCodigoIrregularidade } = data;
    try {
      await API.delete(
        `/detalhesPedido/${idTipoDocumento}/${idCodigoLegado}/${idCodigoIrregularidade}`
      );
      dispatch(
        openToast({
          severity: "success",
          title: "Ocorrência removida",
        })
      );
      dispatch(
        getDetalhesById(
          requestGetParams.matrizConfigApp.detalhesPedido.requestGetParams
        )
      );
    } catch (err) {
      dispatch(
        openModalError({
          title: "Não foi possível remover a ocorrência!",
          text: "Se certifique que a solicitação está correta",
          btnLabel: "Voltar",
        })
      );
      console.error(err);
    }
    return {};
  }
);
